import React from 'react';
import PropTypes from 'prop-types';
import { useSchool } from '../../SchoolContext';
import { getReligionData } from '../../utils';
import ProfileSection from '../ProfileSection';

function Religion({ isFetching }) {
  const { schoolData } = useSchool();

  if (isFetching) {
    return <div>Loading...</div>;
  }

  const { religionName, religionDescription } = getReligionData(schoolData || {});

  if (!religionName || !religionDescription) return <></>;

  return (
    <ProfileSection
      title="Religión"
      subtitleLyrics={{
        subtitle: religionName,
        lyrics: religionDescription,
      }}
    />
  );
}

Religion.propTypes = {
  isFetching: PropTypes.bool.isRequired,
};

export default Religion;
